/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { Switch, Route } from 'react-router-dom';

import ErrorBoundry from 'src/shared/app/base/component/error/ErrorBoundry';
import useReduxState from 'src/shared/app/base/hook/useReduxState';
import useRouteConfig from 'src/shared/app/base/route/hook/useRouteConfig';
import ScrollToTop from 'src/shared/app/base/route/component/ScrollToTop';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { getRoutes } from 'src/shared/app/base/route/registry/routeRegistry';
import {
  getRouteMain,
  getRouteScrollToTop,
} from 'src/shared/app/base/route/util/routeUtils';
import { mainContentId } from 'src/shared/app/nav/settings/navSettings';

type Props = {
  layoutClass?: string,
};

const MainSwitch = ({ layoutClass }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const state = useReduxState();
  const config = useRouteConfig();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <Switch>
      {getRoutes().map((route) => {
        // @TODO - really bad use of hook
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [path] = useRoutes(route);

        return (
          <Route
            path={path}
            exact
            render={() => {
              const children = (
                <main className={layoutClass} id={mainContentId}>
                  <ErrorBoundry>
                    {React.createElement(getRouteMain(route, state, config))}
                  </ErrorBoundry>
                </main>
              );

              return getRouteScrollToTop(route) ? (
                <ScrollToTop>{children}</ScrollToTop>
              ) : (
                children
              );
            }}
            // Use the same key to prevent re-renders when routes share the
            // same main component
            key={1}
          />
        );
      })}
    </Switch>
  );
};

export default compose(React.memo)(MainSwitch);
